/**
 * LakaLogo — Uses the official LAKA CLUB BEAUTY logo.
 * Two variants:
 *  - light bg (default): original logo (black + champagne + tagline)
 *  - dark bg (variant="light"): monochrome ivory version (via CSS filter)
 *    to guarantee contrast without altering brand proportions.
 * Preserves aspect ratio always. Do NOT stretch or crop.
 */
const LOGO_SRC = "/laka-logo.webp";
const ALT = "LAKA CLUB BEAUTY — Estética avanzada & bienestar";

const LakaLogo = ({ className = "h-12", variant = "dark" }) => {
  // "dark" variant means dark-ink logo for light backgrounds (default)
  // "light" variant means ivory logo for dark backgrounds
  const filterStyle =
    variant === "light"
      ? {
          filter: "brightness(0) invert(1)",
          opacity: 0.95,
        }
      : {};

  return (
    <img
      src={LOGO_SRC}
      alt={ALT}
      className={`${className} w-auto select-none`}
      style={{
        objectFit: "contain",
        objectPosition: "left center",
        ...filterStyle,
      }}
      draggable="false"
    />
  );
};

export default LakaLogo;
